<template>
  <div style="height: 100%;">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns" slot-scope="props">
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('email-detail')"
          width="80px"
        >邮件内容
        </grid-table-th>
      </template>
      <template slot="lastBodyColumns" slot-scope="props">
        <grid-table-td
          v-if="props.magicalMenuCodes.includes('email-detail')"
          @click.native="handle(props.row)"
          width="80px"
        >查看
        </grid-table-td>
      </template>
    </grid>
    <whaty-dialog
      title="邮件内容"
      :visible.sync="dialogVisible"
      width="400px"
      top="32vh">
      <div class="popup-wrap" slot="body">
        <div class="popup-body">
          <div class="el-dialog__body whaty-dialog-content">
            <div>主题：{{ title }}</div>
            <div v-html="'正文：'+detail"></div>
            <div v-if="fileCount > 0">
              <div>附件</div>
              <div style="white-space: nowrap;">
                <div style="float: left;">文件名：</div>
                <div class="email-file-area">
                  <div v-for="(fileName,index) in file">
                    <span class="link-normal email-file-name" @click="download(filePath[index], fileName)"
                          v-bind:title="fileName">{{ fileName }}</span>
                    <span class="email-file-size">（{{ fileSize[index] }}）</span>
                    <span class="link-normal email-file-download" @click="download(filePath[index], fileName)">下载</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="popup-foot group" style="padding-right: 0;">
            <a href="javascript:" class="btn btn-solid-primary" @click="dialogVisible = false">确定</a>
          </div>
        </div>
      </div>
    </whaty-dialog>
  </div>
</template>
<script>
import Grid from '../../../../components/grid/grid'
import GridTableTh from '../../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../../components/grid-menu/grid-top-menu'
import util from '../../../../libs/util'
import WhatyDialog from '../../../../components/dialog/dialog'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid,
    WhatyDialog
  },
  name: 'email-send-record-vo',
  data() {
    return {
      gridConfigUrl: '',
      dialogVisible: false,
      title: '',
      detail: '',
      fileCount: '',
      file: '',
      fileSize: '',
      filePath: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handle(data) {
      var this_ = this
      if (data.detail) {
        // 调用接口查询
        util.ajax.get('/entity/notification/emailTaskRecord/detail/' + data.taskId).then(res => {
          if (res.data.success && res.data.data.detail) {
            this_.title = res.data.data.title
            this_.detail = res.data.data.detail
            this_.fileCount = res.data.data.fileCount
            this_.file = res.data.data.file
            this_.fileSize = res.data.data.fileSize
            this_.filePath = res.data.data.filePath
            this_.dialogVisible = true
          } else {
            this.$notify.error({title: '邮件查看', message: '该条记录无邮件内容'})
          }
        }).catch(err => {
          this.$notify.error({title: '错误', message: '获取邮件内容失败！'})
          console.error(err)
        })
      } else {
        this.$notify.error({title: '邮件查看', message: '该条记录无邮件内容'})
      }
    },
    download(path, fileName) {
      var params = {filePath: path, fileName: fileName}
      util.useFormSubmit(util.baseUrl + '/entity/notification/emailTaskRecord/download', params, true)
    }
  }
}
</script>

<style scoped>
  .email-file-name{
    display: inline-block;
    max-width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .email-file-size{
    bottom: 4px;
    position: relative;
  }

  .email-file-area{
    display: inline-block;
    width: 260px;
  }

  .email-file-download{
    float: right;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/grid/notification/email-send-record-vo.vue